<template>
  <!-- Main container for the page -->
  <div class="min-h-screen font-sans bg-brand-bg text-brand-dark">
    <Header />
    <div
      class="flex flex-col items-center px-4 py-10 font-sans text-brand-dark"
    >
      <!-- Main content area for the FAQs -->
      <main class="flex-1 w-full max-w-4xl">
        <div class="mb-8 text-center">
          <!-- <span class="support-eyebrow">Knowledge Base</span> -->
          <h1 class="mb-2 text-3xl font-bold text-brand-dark sm:text-4xl">
            Pre-sales Questions
          </h1>
          <p class="text-brand-gray">
            Find answers about our products and support.
          </p>
        </div>

        <!-- Product Toggles / Switching Buttons -->
        <div
          class="grid grid-cols-5 gap-1 p-1 mb-8 bg-white border border-gray-200 rounded-lg shadow-sm"
          role="tablist"
          aria-label="Product models"
        >
          <button
            v-for="(product, key) in allFaqs"
            :key="key"
            @click="activeProduct = key"
            role="tab"
            :aria-selected="activeProduct === key"
            :class="[
              'min-w-0 px-2 py-2 text-sm font-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-brand-blue transition-colors duration-200',
              activeProduct === key
                ? 'bg-brand-blue text-white'
                : 'text-gray-600 hover:bg-brand-blue-soft hover:text-brand-blue',
            ]"
          >
            {{ product.name }}
          </button>
        </div>

        <!-- FAQ items are generated by looping through the data of the active product -->
        <!-- Each FAQ item is now a self-contained block with spacing -->
        <div
          v-for="(faq, index) in currentFaqs"
          :key="index"
          class="p-6 mb-4 bg-white border border-gray-200 rounded-xl shadow-sm"
        >
          <!-- Question Section -->
          <div class="flex gap-4 items-start">
            <!-- "Q" Avatar Icon -->
            <div
              class="flex flex-shrink-0 justify-center items-center w-9 h-9 font-bold text-brand-blue bg-brand-blue-soft rounded-lg"
            >
              Q
            </div>
            <!-- Question Text -->
            <h2
              class="flex-1 mt-1 text-base font-semibold text-brand-dark sm:text-lg"
            >
              {{ faq.question }}
            </h2>
          </div>

          <!-- Answer Section -->
          <div class="flex gap-4 items-start mt-4">
            <!-- "A" Avatar Icon -->
            <div
              class="flex flex-shrink-0 justify-center items-center w-9 h-9 font-bold text-white bg-brand-blue rounded-lg"
            >
              A
            </div>
            <!-- Answer Text, using v-html to render formatted lists -->
            <p
              class="flex-1 mt-1 leading-relaxed text-brand-gray"
              v-html="faq.answer"
            ></p>
          </div>
        </div>

        <!-- Final contact information section -->
        <div
          class="p-6 mt-6 leading-relaxed text-left text-brand-gray bg-white border border-gray-200 rounded-xl"
        >
          <p>
            If there are have any other questions, please don’t hesitate to
            contact our support team at
            <a
              href="mailto:after-service@elephas.com.hk"
              class="font-medium text-brand-blue hover:underline"
              >after-service@elephas.com.hk</a
            >.
          </p>
          <p class="mt-2">
            We’re always here to help and ensure you have the best experience.
          </p>
        </div>
      </main>

      <!-- <Footer /> -->
    </div>
  </div>
</template>

<script>
// import Footer from '@/components/footer.vue'
import Header from "@/components/header";
import allFaqs from "@/views/FAQ_data.js";
export default {
  name: "PreSalesQuestions",
  components: {
    Header,
  },
  data() {
    return {
      // 1. Add state to track the currently active product
      activeProduct: "googleTV", // Default product to show

      // 2. Restructure FAQs into an object, where each key is a product
      allFaqs,
    };
  },
  computed: {
    // 3. Create a computed property to get the FAQs for the currently active product
    currentFaqs() {
      // It will automatically update when `activeProduct` changes
      return this.allFaqs[this.activeProduct]?.faqs || [];
    },
  },
};
</script>
